import React from 'react';
import { Link } from '../../visions/vx-link';
import flyerPdf from 'file-loader?name=docs/[name].[ext]!../../../assets/docs/compressedupdatedglobalrecallsflyer.compressed.pdf';

const AboutPortal = (props) => (
	<div className="container main">
		<h2>About the portal</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<iframe width="100%" height="310" src="https://player.vimeo.com/video/170923073" frameBorder="0" allowFullScreen=""/>
			</div>		
			<div className="col-sm-6">
				<h4>What is the <em>GlobalRecalls</em> portal?</h4>
				<p>
					The <em>GlobalRecalls</em> Portal brings together information on product recalls issued around the world, on a regular basis,
					together in one place &ndash; an OECD platform. The Portal includes information on mandatory and voluntary consumer product recalls
					issued by, or notified to, a government authority and made publicly available. The scope of the recalls depends on the mandate
					of the particular government authority providing the information. In some cases, recalls for food, vehicles, pharmaceuticals and drugs are included.&nbsp;
				</p>
				<p>The <em>GlobalRecalls</em> Portal was launched on 19 October 2012.</p>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>Who can use the portal?</h4>
				<p>
					The <em>GlobalRecalls</em> Portal enhances information sharing across jurisdictions and supports regulators in taking corrective actions.
					All jurisdictions with their own electronic product recalls database are invited to contribute to the Portal.
				</p>
				<p>
					The Portal is also beneficial for consumers and businesses.
					Consumers can use it to check whether there are safety concerns about the products they intend to buy: particularly useful when making cross-border online purchases.
					And businesses can improve tracking of emerging hazards around the world, which may help them move quicker to address problems in their own products.
				</p>
				<p>The Portal is a particularly valuable source of information for regulators, consumers and businesses in countries that do not have their own online consumer product recalls database.</p>
			</div>
			<div className="col-sm-6">
				<h4>What recalls does the Portal contain?</h4>
				<p>
					The <em>GlobalRecalls</em> Portal currently contains consumer product recalls from 47 jurisdictions globally and integrates recalls from the European Union and ASEAN regional recalls portals.
					It is updated on a regular basis with new and historical data from participating jurisdictions.
				</p>
				<p>
					Each participating jurisdiction may have slight differences in the types of products that fall within their definition of “consumer product”.
					For instance, some countries will include cosmetics as part of their consumer product recalls, while other may include vehicles.
				</p>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>How is the Portal updated?</h4>
				<p>
					Each jurisdiction decides how often and when it sends information to the Portal, with some jurisdictions doing so automatically and some manually depending on their own system.
					Updates may vary from daily to weekly or monthly.
				</p>
			</div>
			<div className="col-sm-6">
				<h4>How long are recalls available on the Portal?</h4>
				<p>Information is stored on the Portal for as long as each individual jurisdiction allows. Some information may therefore be available indefinitely.</p>
			</div>
		</div>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<h4>Could recall information be on the Portal but not on the recalls website of the relevant jurisdiction, or vice versa?</h4>
				<p>
					Each participating jurisdiction decides what information they share on the Portal.
					As such, it may be the case that a jurisdiction has further details on a particular recall on its domestic website.
				</p>
				<p>Participating jurisdictions are generally committed however to sharing all their publicly available recalls via the Portal.</p>
			</div>
		</div>
	</div>
);

export default AboutPortal;



// WEBPACK FOOTER //
// ./src/views/static/en/about-portal.js